import React from "react";
import { Link as RouterLink } from "react-router-dom";
import Placeholder from "../assets/Icon awesome-user-circle@2x.png";
import Camera from "@material-ui/icons/AddAPhoto";
import { storeUserImage } from "../redux/actions/firebaseStorageActions";
import { useDispatch, useSelector } from "react-redux";

const User = ({ openCamera }) => {
  const dispatch = useDispatch();
  const profile = useSelector((state) => state.userProfileReducer.userProfile);

  const handleImage = (e) => {
    dispatch(storeUserImage(e.target.files[0]));
  };

  return (
    <div className=" ">
      <div className=" hidden green-bg md:block md:h-48"></div>
      <div className="flex justify-center  relative">
        <label htmlFor="file" className="w-40  rounded-full   ">
          <img
            src={profile.imgUrl || Placeholder}
            className="margin-photo w-40 rounded-full"
            alt="Placeholder"
          />
          {openCamera ? (
            <Camera className={"-mt-4 cursor-pointer  w-6"} alt="camera" />
          ) : null}
        </label>
        {openCamera ? (
          <input
            type="file"
            id="file"
            className="hidden"
            onChange={handleImage}
          />
        ) : null}
      </div>
      <div className="flex justify-end text-md  md:mx-48 pb-3 pt-8">
        <RouterLink
          to="/activites"
          className="pr-6 py-1 pl-2 hover:border-2 rounded-lg hover:bg-green-400 text-sm hover:text-white"
        >
          نشاطات
        </RouterLink>
        <RouterLink
          to="/profile"
          className="pl-4 pr-6 py-1 hover:border-2 rounded-lg hover:bg-green-400 text-sm hover:text-white"
        >
          معلومات شخصيه
        </RouterLink>
      </div>
    </div>
  );
};
export default User;
